module.exports = __webpack_public_path__ + "assets/images/bag-off-green.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/bag-off-green.png
// module id = 397
// module chunks = 1